'use client';

import type { PropsWithChildren } from 'react';
import NoSSR from '../NoSSR';
import { FullStoryInit } from './FullStoryInit';

export function FullStoryWrapper({ children }: PropsWithChildren) {
	return (
		<>
			<NoSSR>
				<FullStoryInit />
			</NoSSR>
			{children}
		</>
	);
}
